import { queryKeys } from '@/lib/query-keys';
import { apiError } from '@/lib/api/ts-rest';
import { orgMembersClient } from '@/lib/api/ts-rest';
import { useQuery } from '@tanstack/react-query';


interface UseOrganizationMembersParams {
  organizationId: string | undefined;
}

export function useOrganizationMembers({
  organizationId,
}: UseOrganizationMembersParams) {
  return useQuery({
    queryKey: queryKeys.organizations.members(organizationId),
    queryFn: async () => {
      const res = await orgMembersClient.listMembers({
        params: { organizationId: organizationId! },
      });
      if (res.status !== 200) throw apiError(res, 'Failed to load members');
      return res.body;
    },
    enabled: !!organizationId,
    retry: false,
  });
}
